import * as d3 from 'd3'
import Defs from '../../../../includes/primitives/colorDefs'

export default {
  methods: {

    Chart_Gauge(selection) {

      let circle = this.circle
      let backgound = this.circle.backgound
      let needle = this.circle.needle
      let endAn = ''

      let gauge = selection
      .append('g')
      .attr('transform', `translate(${circle.x + circle.radius},${circle.y + circle.radius})`)


      // Gauge Gride - Background ----------------------------------------------
      var arcBg = d3.arc()
      .innerRadius(circle.radius)
      .outerRadius(circle.radius - circle.thick)
      .startAngle(this.angle.start * Math.PI / 180)
      .endAngle(this.angle.end * Math.PI / 180)

      gauge
      .append('path')
      .attr('d', arcBg)
      .attr('fill', backgound.color)
      .attr('opacity', backgound.opacity)
      .attr('transform', `translate(${0}, ${0})`)


      // Forecast ---------------------------------------------------------------
      let gaugePro = this.rawData.ACTUAL/this.rawData.TOTAL
      let fcPro = this.rawData.FORECAST/this.rawData.TOTAL
      let data = this.columns.find(f=> f.code == 'FORECAST')

      let fc = -90 + fcPro * 180
      let y1 = -circle.radius -3
      let y2 = y1 + circle.thick + 3

      for (var n = -90;n <= 90;n += this.angle.size/64) {
        gauge
        .append('line')
        .attr('x1', 0).attr('y1', y1+3)
        .attr('x2', 0).attr('y2', y2)
        .attr('stroke', 'white').attr('stroke-width', circle.grid)
        .attr('transform', () => `rotate(${n},${0},${0})`)
      }

      gauge
      .append('line')
      .attr('x1', 0).attr('y1', y1)
      .attr('x2', 0).attr('y2', y2)
      .attr('stroke', data.stroke).attr('stroke-width', 1)
      .attr('transform', () => `rotate(${fc},${0},${0})`)

      gauge
      .append('circle')
      .attr('cx', 0).attr('cy', y1)
      .attr('r', 1.5).attr('fill', '#fff')
      .attr('stroke', data.stroke).attr('stroke-width', 1)
      .attr('transform', () => `rotate(${fc},${0},${0})`)
      
      let x = (circle.radius + 5) * Math.sin((180-fc) * Math.PI/180)
      let y = (circle.radius + 5) * Math.cos((180-fc) * Math.PI/180)
      gauge
      .append('text')
      .attr('transform', `translate(${x}, ${y})`)
      .style('font-size', data.tSize).attr('fill', data.tColor)
      .attr('text-anchor', () => {
        let align = 'middle'
        if(fcPro < .45 ) return align = 'end'
        if(fcPro > .55) return align = 'start'
        return align
      })
      .text(this.rawData.FORECAST)
      .call(this.event_Link, data)


      // Gauge Gride - Front ----------------------------------------------
      let st = 0
      let an = this.angle.size
      st = this.angle.start
      an = this.angle.end

      let arc = d3.arc()
      .outerRadius(circle.radius)
      .innerRadius(circle.radius - circle.thick)
      .startAngle(this.angle.start * Math.PI / 180)
      .endAngle(() => endAn || this.angle.start * Math.PI / 180)

      gauge
      .append('path')
      .attr('d', arc)
      .attr('fill', circle.color.charAt(0) == '#' ? circle.color : `url(#${this.localId}_${circle.color})`)
      .attr('opacity', circle.opacity)
      .attr('transform', `translate(0, 0)`)
      .transition()
      .duration(750)
      .attrTween('d', ()=> {
        let endAngle_ = ( ((this.angle.size * gaugePro) + this.angle.start) * Math.PI / 180)
        let interpolate = d3.interpolate(this.angle.start * Math.PI / 180, endAngle_)
        return function(t) {
          endAn = interpolate(t)
          return arc()
        }
      })
      

      // needle
      let needleLen = circle.radius - circle.thick
      let needleRadius = 5
      let percent = 0
      let thetaRad = percent * Math.PI

      let topX = -needleLen * Math.cos(thetaRad)
      let topY = -needleLen * Math.sin(thetaRad)

      let leftX = -needleRadius * Math.cos(thetaRad - Math.PI / 2)
      let leftY = -needleRadius * Math.sin(thetaRad - Math.PI / 2)

      let rightX = -needleRadius * Math.cos(thetaRad + Math.PI / 2)
      let rightY = -needleRadius * Math.sin(thetaRad + Math.PI / 2)

      gauge
      .append('path')
      .attr('id', `needle_${this.localId}`)
      .attr('d', `M ${leftX} ${leftY} L ${topX} ${topY} L ${rightX} ${rightY}`)
      .attr('fill', `url(#${this.localId}_${needle.color}_H2)`)

      d3.select(`#needle_${this.localId}`)
      .transition().duration(750)
      .attr('transform', `translate(0,0) rotate(${gaugePro * 180})`)

      gauge
      .append('circle').attr('cx', 0).attr('cy', 0).attr('r', 5).attr('fill', `url(#${this.localId}_${needle.color}_H2)`)
      gauge
      .append('circle').attr('cx', 0).attr('cy', 0).attr('r', 2).attr('fill', '#bcbcbc')
        
      // Progress(%)
      data = this.columns.find(f=> f.code == 'ACTUAL')
      gauge
      .append('text')
      .attr('transform', `translate(0, ${needle.proY + data.tSize*0.75})`)
      .attr('font-size', data.tSize).attr('fill', data.tColor)
      .attr('text-anchor', 'middle')
      .text(this.rawData.ACTUAL)
      .call(this.event_Link, data)

      data = this.columns.find(f=> f.code == 'TOTAL')
      gauge
      .append('text')
      .attr('transform', `translate(${this.circle.radius + 5}, ${data.tSize*0.36})`)
      .attr('font-size', data.tSize).attr('fill', data.tColor)
      .attr('text-anchor', 'start')
      .text(this.rawData.TOTAL)
      .call(this.event_Link, data)

      gauge
      .append('text')
      .attr('transform', `translate(${-this.circle.radius - 5}, ${data.tSize*0.36})`)
      .attr('font-size', data.tSize).attr('fill', data.tColor)
      .attr('text-anchor', 'end')
      .text(0)

    },

    
  }
}